import { AbstractControl, ValidatorFn } from "@angular/forms";

export function CUIValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const regex = /^([rR][oO]\d{3,10}|\d{3,10})$/;

        if (value && !regex.test(value)) {
            return { invalidCUI: true };
        }

        return null;
    };
}